<!-- CONTENEDOR PRINCIPAL -->
<div class="qr-ranking-item-main-container" *ngIf="data">
  <!-- PRIMER BLOQUE  -->
  <div class="first-block" [ngClass]="{ expand: this.expand }">
    <div class="separate-content">
      <!-- POSICION EN LA LISTA  -->
      <div class="position-list">
        <p class="heading-01-semi-bold">#{{ this.index + 1 }}</p>
      </div>
      <!-- POSICION MENSUAL  -->
      <div class="position-container selected" id="monthly">
        <p class="position display-01-bold">
          {{ data.rankingMensualCorriente }}
        </p>
        <p class="type subheading-01-semi-bold">MENSUAL</p>
      </div>
      <div
        class="icon-up-down"
        [ngClass]="
          data.rankingMensualCorriente < data.rankingMensualAnterior
            ? 'up'
            : 'down'
        "
      >
        <qr-icon name="arrow-drop-down" color="green"></qr-icon>
      </div>
      <!-- POSICION ANUAL  -->
      <div class="position-container" id="anual">
        <p class="position display-01-bold">
          #{{ data.rankingAcumuladoCorriente }}
        </p>
        <p class="type subheading-01-semi-bold">ANUAL</p>
      </div>
      <div
        class="icon-up-down"
        [ngClass]="
          data.rankingAcumuladoCorriente < data.rankingAcumuladoAnterior
            ? 'up'
            : 'down'
        "
      >
        <qr-icon name="arrow-drop-down" color="green"></qr-icon>
      </div>

      <!-- CONTENEDOR NOMBRE DE LA OFICINA  -->
      <div class="office-container">
        <div class="new-ranking-container" *ngIf="this.NODE == this.NODE_AR">
          <div
            class="new-ranking"
            matTooltip="Productividad individual"
            matTooltipPosition="above"
          >
            <p>PI #{{ data.rankingA }}</p>
            <div class="icon">
              <ng-container [ngSwitch]="true">
                <qr-icon
                  *ngSwitchCase="data.rankingA < data.rankingAAnterior"
                  name="arrow-drop-up"
                  color="success-500"
                ></qr-icon>
                <qr-icon
                  *ngSwitchCase="data.rankingA > data.rankingAAnterior"
                  name="arrow-drop-down"
                  color="error-500"
                ></qr-icon>
                <div
                  class="equal"
                  *ngSwitchCase="data.rankingA == data.rankingAAnterior"
                ></div>
              </ng-container>
            </div>
          </div>
          <div
            class="new-ranking"
            matTooltip="Equipo productivo"
            matTooltipPosition="above"
          >
            <p>EP #{{ data.rankingB }}</p>
            <div class="icon">
              <ng-container [ngSwitch]="true">
                <qr-icon
                  *ngSwitchCase="data.rankingB < data.rankingBAnterior"
                  name="arrow-drop-up"
                  color="success-500"
                ></qr-icon>
                <qr-icon
                  *ngSwitchCase="data.rankingB > data.rankingBAnterior"
                  name="arrow-drop-down"
                  color="error-500"
                ></qr-icon>
                <div
                  class="equal"
                  *ngSwitchCase="data.rankingB == data.rankingBAnterior"
                ></div>
              </ng-container>
            </div>
          </div>
          <div
            class="new-ranking"
            matTooltip="Alto rendimiento"
            matTooltipPosition="above"
          >
            <p>AR #{{ data.rankingC }}</p>
            <div class="icon">
              <ng-container [ngSwitch]="true">
                <qr-icon
                  *ngSwitchCase="data.rankingC < data.rankingCAnterior"
                  name="arrow-drop-up"
                  color="success-500"
                ></qr-icon>
                <qr-icon
                  *ngSwitchCase="data.rankingC > data.rankingCAnterior"
                  name="arrow-drop-down"
                  color="error-500"
                ></qr-icon>
                <div
                  class="equal"
                  *ngSwitchCase="data.rankingC == data.rankingCAnterior"
                ></div>
              </ng-container>
            </div>
          </div>
        </div>

        <p class="display-02-black" matTooltip="{{ data.name }}">
          {{ data.name }}
        </p>
      </div>
    </div>
    <!-- BOTON PARA EXPANDIR  -->
    <div>
      <qr-button [config]="buttonExpand" (click)="onClickExpand()"></qr-button>
    </div>
  </div>

  <!-- SEGUNDO BLOQUE  -->
  <div class="animation-second-block" [ngClass]="{ expand: this.expand }">
    <div
      class="second-block"
      [ngClass]="{ 'filter-open': filterOpen }"
      *ngIf="this.expand"
    >
      <!-- REGION  -->
      <div class="item-second-block">
        <div class="icon">
          <qr-icon name="location" color="grey-700"></qr-icon>
        </div>
        <div class="data-container">
          <p class="title subheading-01-semi-bold">REGION</p>
          <p class="data subheading-01-bold">
            {{ printRegion() }}
          </p>
        </div>
      </div>
      <!-- CARTERA ACTIVA  -->
      <div class="item-second-block">
        <div class="icon">
          <qr-icon name="properties" color="grey-700"></qr-icon>
        </div>
        <div class="data-container">
          <p class="title subheading-01-semi-bold">CARTERA ACTIVA</p>
          <p class="data subheading-01-bold">
            {{ data.carteraActivaMensual ? data.carteraActivaMensual : "-" }}
            {{
              data.porcentajeExclusividadMensual
                ? "(" +
                  data.porcentajeExclusividadMensual +
                  "% de exclusividad)"
                : ""
            }}
          </p>
        </div>
      </div>
      <!-- CANTIDAD DE AGENTES  -->
      <div class="item-second-block">
        <div class="icon">
          <qr-icon name="persons" color="grey-700"></qr-icon>
        </div>
        <div class="data-container">
          <p class="title subheading-01-semi-bold">CANTIDAD DE AGENTES</p>
          <p class="data subheading-01-bold">
            {{
              data.cantidadAgentesMensuales
                ? data.cantidadAgentesMensuales
                : "-"
            }}
          </p>
        </div>
      </div>
      <!-- ANTIGUEDAD DE AGENTES  -->
      <div class="item-second-block">
        <div class="icon">
          <qr-icon name="calendar-account" color="grey-700"></qr-icon>
        </div>
        <div class="data-container">
          <p class="title subheading-01-semi-bold">ANTIGUEDAD DE AGENTES</p>
          <p class="data subheading-01-bold">
            {{
              data.antiguedadPromedioAgentes !== null
                ? (data.antiguedadPromedioAgentes / 365).toFixed(1) + " años"
                : "-"
            }}
          </p>
        </div>
      </div>
      <!-- ANTIGUEDAD DE OFICINA  -->
      <div class="item-second-block">
        <div class="icon">
          <qr-icon name="calendar-work" color="grey-700"></qr-icon>
        </div>
        <div class="data-container">
          <p class="title subheading-01-semi-bold">ANTIGUEDAD DE OFICINA</p>
          <p class="data subheading-01-bold">
            {{
              data.antiguedadOficina !== null
                ? (data.antiguedadOficina / 365).toFixed(1) + " años"
                : "-"
            }}
          </p>
        </div>
      </div>
      <!-- NUEVAS CAPTACIONES MENSUALES  -->
      <div class="item-second-block">
        <div class="icon">
          <qr-icon name="new-properties" color="grey-700"></qr-icon>
        </div>
        <div class="data-container">
          <p class="title subheading-01-semi-bold">
            NUEVAS CAPTACIONES MENSUALES
          </p>
          <p class="data subheading-01-bold">
            {{
              data.nuevasCaptacionesMensual
                ? data.nuevasCaptacionesMensual
                : "-"
            }}
            {{
              data.nuevasCaptacionesAcumuladas
                ? "(" + data.nuevasCaptacionesAcumuladas + " acumuladas)"
                : ""
            }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- TERCER BLOQUE  -->
  <!-- Solo visible si es mi oficina o alguna de mis "multioficina" -->
  <div
    class="animation-third-block"
    [ngClass]="{ expand: this.expand }"
    *ngIf="isBlockVisible(3)"
  >
    <div class="third-block" *ngIf="this.expand">
      <!-- ACUMULADO TRENDING  -->
      <div class="item-trend-container">
        <div class="data-container">
          <p class="title subheading-01-semi-bold">ACUMULADO</p>
          <p class="data subheading-01-bold">
            {{
              data.comisionesAcumuladas !== null
                ? formatNumberDot(data.comisionesAcumuladas.toFixed())
                : "-"
            }}
            <span
              class="percentage-trend"
              matTooltip="Porcentaje de objetivo alcanzado"
            >
              <!-- TODO: el icono por ahora no va hasta que del servicio venga si es ⬇ o ⬆ -->
              <!-- <qr-icon
                *ngIf="data.objetivoComisionesAcumuladas"
                name="trending-up"
                color="success-700"
              ></qr-icon>
              <qr-icon
                *ngIf="false"
                name="trending-down"
                color="error-900"
              ></qr-icon> -->
              {{
                data.objetivoComisionesAcumuladas > 0
                  ? " " +
                    (
                      (data.comisionesAcumuladas * 100) /
                      data.objetivoComisionesAcumuladas
                    ).toFixed() +
                    "%"
                  : ""
              }}
            </span>
          </p>
        </div>
      </div>
      <!-- MENSUAL TRENDING  -->
      <div class="item-trend-container">
        <div class="data-container">
          <p class="title subheading-01-semi-bold">MENSUAL</p>
          <p class="data subheading-01-bold">
            {{
              data.comisionesMensuales
                ? formatNumberDot(data.comisionesMensuales)
                : "-"
            }}
            <span
              class="percentage-trend"
              matTooltip="Porcentaje de objetivo alcanzado"
            >
              <!-- <qr-icon
                *ngIf="data.objetivoComisionesMensuales"
                name="trending-up"
                color="success-700"
              ></qr-icon>
              <qr-icon
                *ngIf="false"
                name="trending-down"
                color="error-900"
              ></qr-icon> -->
              {{
                data.objetivoComisionesMensuales > 0
                  ? " " +
                    (
                      (data.comisionesMensuales * 100) /
                      data.objetivoComisionesMensuales
                    ).toFixed() +
                    "%"
                  : ""
              }}
            </span>
          </p>
        </div>
      </div>
      <!-- EXP ACUMULADAS TRENDING  -->
      <div class="item-trend-container">
        <div class="data-container">
          <p class="title subheading-01-semi-bold">EXP. ACUMULADAS</p>
          <p class="data subheading-01-bold">
            {{
              data.transaccionesAcumuladas ? data.transaccionesAcumuladas : "-"
            }}
            <span
              class="percentage-trend"
              matTooltip="Porcentaje de objetivo alcanzado"
            >
              <!-- <qr-icon
                *ngIf="data.objetivoTransaccionesAcumuladas"
                name="trending-up"
                color="success-700"
              ></qr-icon>
              <qr-icon
                *ngIf="false"
                name="trending-down"
                color="error-900"
              ></qr-icon> -->
              {{
                data.objetivoTransaccionesAcumuladas > 0
                  ? " " +
                    (
                      (data.transaccionesAcumuladas * 100) /
                      data.objetivoTransaccionesAcumuladas
                    ).toFixed() +
                    "%"
                  : ""
              }}
            </span>
          </p>
        </div>
      </div>
      <!-- EXP MENSUALES TRENDING  -->
      <div class="item-trend-container">
        <div class="data-container">
          <p class="title subheading-01-semi-bold">EXP. MENSUALES</p>
          <p class="data subheading-01-bold">
            {{
              data.transaccionesMensuales ? data.transaccionesMensuales : "-"
            }}
            <span
              class="percentage-trend"
              matTooltip="Porcentaje de objetivo alcanzado"
            >
              <!-- <qr-icon
                *ngIf="data.objetivoTransaccionesMensuales"
                name="trending-up"
                color="success-700"
              ></qr-icon>
              <qr-icon
                *ngIf="false"
                name="trending-down"
                color="error-900"
              ></qr-icon> -->
              {{
                data.objetivoTransaccionesMensuales > 0
                  ? " " +
                    (
                      (data.transaccionesMensuales * 100) /
                      data.objetivoTransaccionesMensuales
                    ).toFixed() +
                    "%"
                  : ""
              }}
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- CUARTO BLOQUE  -->
  <!-- Este bloque debe ocultarse en EC y PY -->
  <div
    class="animation-fourth-block"
    [ngClass]="{ expand: this.expand }"
    *ngIf="isBlockVisible(4)"
  >
    <div class="fourth-block" *ngIf="this.expand">
      <div class="data-container office-category">
        <p class="title subheading-01-semi-bold">CATEGORÍA OFICINA</p>
        <p class="data subheading-01-bold">{{ data.categoria }}</p>
      </div>
      <div class="data-container">
        <p class="title subheading-01-semi-bold">P.I</p>
        <p
          class="data subheading-01-bold"
          [ngClass]="data.kpiProdIndividualColor == 1 ? 'red' : ''"
        >
          {{ data.kpiProdIndividual }}
        </p>
      </div>
      <div class="data-container">
        <p class="title subheading-01-semi-bold">%EP</p>
        <p
          class="data subheading-01-bold"
          [ngClass]="data.kpiEquipoProductivoColor == 1 ? 'red' : ''"
        >
          {{
            data.kpiEquipoProductivo !== null
              ? data.kpiEquipoProductivo.toFixed()
              : "-"
          }}
        </p>
      </div>
      <div class="data-container">
        <p class="title subheading-01-semi-bold">%AR</p>
        <p
          class="data subheading-01-bold"
          [ngClass]="data.kpiAltoRendimientoColor == 1 ? 'red' : ''"
        >
          {{
            data.kpiAltoRendimiento !== null
              ? data.kpiAltoRendimiento.toFixed()
              : "-"
          }}
        </p>
      </div>
      <div class="data-container">
        <p class="title subheading-01-semi-bold">%RED / 2P / FUERA</p>
        <p
          class="data subheading-01-bold"
          [ngClass]="data.kpiCompartidasColor == 1 ? 'red' : ''"
        >
          {{
            data.kpiCompartidas !== null ? data.kpiCompartidas.toFixed() : "-"
          }}
          /
          {{
            data.kpiCompartidasDosP !== null
              ? data.kpiCompartidasDosP.toFixed()
              : "-"
          }}
          /
          {{
            data.kpiCompartidasFueraRed !== null
              ? data.kpiCompartidasFueraRed.toFixed()
              : "-"
          }}
        </p>
      </div>
      <div class="data-container">
        <p class="title subheading-01-semi-bold">%ROT</p>
        <p
          class="data subheading-01-bold"
          [ngClass]="data.kpiRotacionColor == 1 ? 'red' : ''"
        >
          {{ data.kpiRotacion !== null ? data.kpiRotacion.toFixed() : "-" }}
        </p>
      </div>
      <div class="data-container">
        <p class="title subheading-01-semi-bold">%TRX</p>
        <p
          class="data subheading-01-bold"
          [ngClass]="data.kpiTransaccionesColor == 1 ? 'red' : ''"
        >
          {{ data.kpiTransacciones || "-" }}
        </p>
      </div>
      <div class="data-container">
        <qr-button
          *ngIf="!filterOpen"
          [config]="buttonAverages"
          (click)="averages()"
        ></qr-button>
        <qr-button
          *ngIf="filterOpen"
          [config]="buttonAveragesOnlyIcon"
          (click)="averages()"
        ></qr-button>
      </div>
    </div>
  </div>
</div>
